import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class SharedClientService {

    constructor() { }
    hasAddressChanged(originalAddress: CmAddress, currentAddress: CmAddress): boolean {
        const areEquivalentValues = (value1: any, value2: any): boolean => {
            const normalize = (value: any) => value?.trim?.() ?? '';

            const normalizedValue1 = normalize(value1);
            const normalizedValue2 = normalize(value2);

            return normalizedValue1 === normalizedValue2;
        };

        return (
            !areEquivalentValues(originalAddress.addressline1, currentAddress.addressline1) ||
            !areEquivalentValues(originalAddress.addressline2, currentAddress.addressline2) ||
            !areEquivalentValues(originalAddress.suburb, currentAddress.suburb) ||
            !areEquivalentValues(originalAddress.state, currentAddress.state) ||
            !areEquivalentValues(originalAddress.postcode, currentAddress.postcode) ||
            !areEquivalentValues(originalAddress.country, currentAddress.country)
        );
    }
}
export class CmAddress {
    addressId: number;
    addressline1: string;
    addressline2: string;
    suburb: string;
    state: string;
    postcode: string;
    country: string;
    contestId?: number
    contestType?: string;
    stateName: string;
    countryName: string;
  }
  